<template>
    <v-form
        ref="procedureForm"
        v-model="formValid"
        v-resize="onResize"
    >
        <template v-if="procedureDataForm.previous_url != null || procedureDataForm.next_url != null">
            <v-row v-if="valuesInit">
                <template v-for="formField in form">
                    <v-col
                            :cols="getColSize(formField, 'xs')"
                            :sm="getColSize(formField, 'sm')"
                            :md="getColSize(formField, 'md')"
                            :lg="getColSize(formField, 'lg')"
                            :key="formField.id"
                            v-if="validDependent(formField)"
                    >

                        <paragraph-field
                            v-if="formField.tipo === 'paragraph'"
                            :field="formField"
                        />
                        <TitleField
                            v-if="formField.tipo === 'title'"
                            :field="formField"
                        />
                        <SubtitleField
                            v-if="formField.tipo === 'subtitle'"
                            :field="formField"
                        />
                        <VariableField
                            v-if="formField.tipo === 'variable'"
                            :field="formField"
                        />
                        <text-field
                            v-if="formField.tipo === 'text'"
                            :field="formField"
                            :readonly="validateFieldReadOnly(formField)"
                            :default_value="validateDefaultValue(formField)"
                            :label="getLabel(formField)"
                            :formValues="formValues"
                            :api-ajax="findApiAjaxDependent(formField)"
                        />
                        <text-area
                            v-if="formField.tipo === 'textarea'"
                            :field="formField"
                            :readonly="validateFieldReadOnly(formField)"
                            :default_value="validateDefaultValue(formField)"
                            :label="getLabel(formField)"
                            :formValues="formValues"
                        />
                        <SelectField
                            v-if="formField.tipo === 'select'"
                            :field="formField"
                            :readonly="validateFieldReadOnly(formField)"
                            :default_value="validateDefaultValue(formField)"
                            :label="getLabel(formField)"
                            :stageId="procedureMeta.etapa_id"
                            :formValues="formValues"
                            :api-ajax="findApiAjaxDependent(formField)"
                        />
                        <DateField
                            v-if="formField.tipo === 'date'"
                            :field="formField"
                            :readonly="validateFieldReadOnly(formField)"
                            :default_value="validateDefaultValue(formField)"
                            :label="getLabel(formField)"
                            :formValues="formValues"
                        />
                        <CheckboxField
                            v-if="formField.tipo === 'checkbox'"
                            :field="formField"
                            :readonly="validateFieldReadOnly(formField)"
                            :default_value="validateDefaultValue(formField)"
                            :label="getLabel(formField)"
                            :formValues="formValues"
                            :dynamic-table="false"
                        />
                        <RadioField
                            v-if="formField.tipo === 'radio'"
                            :field="formField"
                            :readonly="validateFieldReadOnly(formField)"
                            :default_value="validateDefaultValue(formField)"
                            :label="getLabel(formField)"
                            :formValues="formValues"
                        />
                        <QR
                            v-if="formField.tipo === 'qr'"
                            :field="formField"
                            :readonly="validateFieldReadOnly(formField)"
                            :default_value="validateDefaultValue(formField)"
                            :label="getLabel(formField)"
                            :formValues="formValues"
                        />
                        <TableStaticField
                            v-if="formField.tipo === 'table_static'"
                            :field="formField"
                            :readonly="validateFieldReadOnly(formField)"
                            :default_value="validateDefaultValue(formField)"
                            :label="getLabel(formField)"
                            :formValues="formValues"
                        />
                        <TableDynamicField
                            v-if="formField.tipo === 'table_dynamic'"
                            :field="formField"
                            :readonly="validateFieldReadOnly(formField)"
                            :default_value="validateDefaultValue(formField)"
                            :label="getLabel(formField)"
                            :columnsHide="columnsToHideTD"
                            :formValues="formValues"
                            @returnDeleteElements="deleteElementRow"
                        />
                        <FileField
                            v-if="formField.tipo === 'file'"
                            :field="formField"
                            :readonly="validateFieldReadOnly(formField)"
                            :default_value="validateDefaultValue(formField)"
                            :label="getLabel(formField)"
                            :formValues="formValues"
                            :dynamic-table="false"
                        />

                        <JavascriptField
                            v-if="formField.tipo === 'javascript'"
                            :field="formField"
                        />
                        <RedirectField
                            v-if="formField.tipo === 'redirect'"
                            :field="formField"
                            :readonly="validateFieldReadOnly(formField)"
                            :default_value="validateDefaultValue(formField)"
                            :label="getLabel(formField)"
                            :formValues="formValues"
                        />
                        <MapField
                            v-if="formField.tipo === 'map'"
                            :field="formField"
                            :readonly="validateFieldReadOnly(formField)"
                            :default_value="validateDefaultValue(formField)"
                            :label="getLabel(formField)"
                            :formValues="formValues"
                        />
                        <CartField
                            v-if="formField.tipo === 'cart'"
                            :field="formField"
                            :readonly="validateFieldReadOnly(formField)"
                            :default_value="validateDefaultValue(formField)"
                            :label="getLabel(formField)"
                            :formValues="formValues"
                            :procedure-id="procedureMeta.tramite_id"
                            :stage-id="procedureMeta.etapa_id"
                        />

                        <DocumentField
                            v-if="formField.tipo === 'documento' || formField.tipo === 'signed_document'"
                            :field="formField"
                            :default_value="validateDefaultValue(formField)"
                        />

                        <SubmitField
                            v-if="formField.tipo === 'submit'"
                            :field="formField"
                            :default_value="validateDefaultValue(formField)"
                        />

                        <FirmaDigitalField
                            v-if="formField.tipo === 'firma'"
                            :field="formField"
                            :readonly="validateFieldReadOnly(formField)"
                            :default_value="validateDefaultValue(formField)"
                            :label="getLabel(formField)"
                            :formValues="formValues"
                        />

                        <AutographSignatureField 
                            v-if="formField.tipo === 'autograph_signature'"
                            :width="formField.extra.width" 
                            :height="formField.extra.height" 
                            :with_video='formField.extra.with_video'
                            :field="formField" 
                            :stageId="procedureMeta.etapa_id"
                            :formValues="formValues"
                        />

                        <OpenAI  
                            v-if="formField.tipo === 'open_ai'"
                            :etiqueta="formField.etiqueta"
                            :initial_conversation="formField.extra.mensaje_inicial"
                            :url_auth="formField.extra.url_token"
                            :username="formField.extra.usuario"
                            :password="formField.extra.password"
                            :url_open_ai="formField.extra.url_query"
                            :field="formField"
                            :formValues="formValues"
                        />

                        <Streaming 
                            v-if="formField.tipo === 'streaming'"
                            :field="formField"
                            :formValues="formValues"
                            :tramite_id="procedureMeta.tramite_id"
                            :width="formField.extra.width" 
                            :height="formField.extra.height" 
                        />

                        <ApiAjaxField
                            v-if="formField.tipo === 'api_ajax'"
                            :field="formField"
                            :default_value="validateDefaultValue(formField)"
                            :formValues="formValues"
                            :procedure-id="procedureMeta.tramite_id"
                            :stage-id="procedureMeta.etapa_id"
                        />

                    </v-col>
                </template>
            </v-row>
            <v-row>
                <v-col cols="12" class="d-flex justify-center">
                    <template v-if="procedureDataForm.previous_url != null">
                        <v-alert
                            v-if="procedureDataForm.status === 'sincontinuacion'"
                            v-bind:type="'error'"
                            dismissible
                        >
                            {{ procedureDataForm.api_message }}
                        </v-alert>
                        <v-btn
                            class="normal mr-2" large
                            @click="submitPreviousStep()"
                        >
                            <v-icon left>fas fa-chevron-left</v-icon>
                            {{!isMobile ? 'Anterior' : ''}}
                        </v-btn>

                    </template>

                    <!-- DISABLE BUTTON FOR EFIRMA -->
                    <v-btn
                        v-if="procedureDataForm.next_url != null && procedureDataForm.status !== 'sincontinuacion'"
                        depressed
                        color="main_color"
                        @click="submitNextStep"
                        large
                        class="btn btn-primary btn-siguiente white--text"
                    >
                        {{!isMobile ? 'Siguiente' : 'Sig.'}}
                        <v-icon right>fas fa-chevron-right</v-icon>
                    </v-btn>

                    <!-- Si el trámite está en carrito -->
                    <v-btn
                        v-if="cartStore.isProcedureInCart && !cartStore.order"
                        :to="{name: 'portfolio', params:{step: 1}}"
                        depressed
                        color="yellow darken-3"
                        large
                        class="btn btn-primary white--text ms-1 pt-3"
                    >
                        Mis pagos
                    </v-btn>

                    <!-- Si el trámite ya pasó a orders -->
                    <v-btn 
                        v-if="cartStore.isProcedureInCart && cartStore.order"
                        :to="{name: 'orders_details', params:{action: 'edit', id: cartStore.order}}"
                        depressed
                        color="yellow darken-3"
                        large
                        class="btn btn-primary white--text ms-1 pt-3"
                    >
                        Retomar pago
                    </v-btn>

                </v-col>
            </v-row>
        </template>
        <v-row v-else>
            <v-col cols="12">
                <v-alert :type="'info'" dismissible>
                    {{ procedureDataForm.api_message }}
                </v-alert>
            </v-col>
            <v-col cols="12" class="d-flex justify-center">
                <router-link :to="{name: 'processes'}">
                    <v-btn color="main_color white--text">Ir al inicio</v-btn>
                </router-link>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
    import Vue from 'vue'
    import {mapGetters, mapState, mapActions} from "vuex";
    import evaluate from 'simple-evaluate'
    import {
        TextField, TextArea, ParagraphField, TitleField, SubtitleField, VariableField,
        SelectField, CheckboxField, RadioField, FileField,
        DateField, QR, TableStaticField, TableDynamicField,
        JavascriptField, RedirectField, MapField, CartField,
        DocumentField, FirmaDigitalField, SubmitField, ApiAjaxField, AutographSignatureField, OpenAI, Streaming
    } from './FormFields/'
    import {bootstrapSizeToVuetify, expresionToArray} from "../../core/utils";
    // eslint-disable-next-line no-unused-vars
    import {procedureSubmitNextRequest} from "@/api/models";

    export default {

        computed: {
            ...mapState({proceduresStore: state => state.procedures, cartStore: state => state.cart}),
            ...mapGetters('procedures', ['procedureDataForm', 'form', 'procedureData', 'procedureMeta'])
        },
        components: {
            ParagraphField, TitleField, SubtitleField, VariableField,
            TextField, TextArea, SelectField, CheckboxField, RadioField,FileField,
            DateField, QR, TableStaticField, TableDynamicField,
            JavascriptField, RedirectField, MapField, CartField,
            DocumentField, FirmaDigitalField, SubmitField, ApiAjaxField,AutographSignatureField, OpenAI, Streaming
        },

        props: ['procedureAction'],

        data() {
            return {
                formValid: false,
                name: '',
                searchKey: '',
                columnsToHideTD: [],
                rowsDeleted: null,
                formValues: {},
                dynamicValues: [],
                valuesInit: false,
                formComponentsVisible: {},
                //eslint-disable-next-line
                regex: /[()""{}\[\]]/g ,
                apiAjaxComponents: {},
                isMobile: false,
            }
        },

        updated() {
            if (!this.valuesInit && this.procedureDataForm != null){
                this.initFormValues()
                this.showFormErrors()
            }
        },

        methods: {
            ...mapActions('procedures', ['submitProcedureNextStep', 'getProcedureExecutedStep']),
            ...mapGetters('procedures', ['isPostNextRequest', 'formErrors']),
            ...mapActions('alerts', ['success', 'error']),

            initFormValues(){
                this.form.forEach((formField) => {
                    if (formField.tipo === 'firma'){
                        Vue.set(this.formValues, formField.datos.certificado.name, formField.datos.certificado.value)
                        Vue.set(this.formValues, 'original_message', formField.datos.final_sign_string)
                        if (formField.value != null && formField.value.signed_message != undefined){
                            Vue.set(this.formValues, 'signed_message', formField.value.signed_message)
                        }else {
                            Vue.set(this.formValues, 'signed_message', '')
                        }
                    }
                    else if (formField.tipo === 'table_dynamic'){
                        this.searchKey = formField.nombre
                        this.columnsToHideTD = formField.datos.is_checked
                        Vue.set(this.formValues, formField.nombre, JSON.stringify(formField.value))
                    }
                    else if (formField.tipo === 'file'){
                        Vue.set(this.formValues, formField.nombre, formField.decodeJson)
                    }else if (formField.tipo === 'api_ajax'){
                        this.addAndPrepareApiAjax(formField)
                    }
                    else if (!['paragraph', 'title', 'subtitle', 'api_ajax'].includes(formField.tipo)) {
                        Vue.set(this.formValues, formField.nombre, formField.value)
                    }

                    this.valuesInit = true
                })
            },

            deleteElementRow(value){
                var arrayValues
                if (this.rowsDeleted === null) {
                    this.rowsDeleted = value
                    arrayValues = JSON.parse(JSON.parse(this.formValues[this.searchKey]))
                    arrayValues.splice(value, 1)
                    this.dynamicValues = arrayValues
                } else {
                    this.rowsDeleted = value
                    arrayValues = this.dynamicValues
                    arrayValues.splice(value, 1)
                    this.dynamicValues = arrayValues
                }
            },

            submitNextStep(){
                this.$refs.procedureForm.validate()

                if (this.formValid){
                    this.removeUnnecessaryFormValues()

                    let request = procedureSubmitNextRequest()
                    request.processId = this.procedureMeta.proceso_id
                    request.lastAction = this.procedureAction
                    
                    request.url = this.procedureDataForm.next_url.replace(process.env.VUE_APP_API_BASE_URL, '')
                    if (this.rowsDeleted != null) { // update the rows available in dynamic table if has changes
                        this.formValues[this.searchKey] = JSON.stringify(JSON.stringify(this.dynamicValues))
                        request.data = this.formValues
                        this.rowsDeleted = null
                    } else {
                        request.data = this.formValues
                    }

                    if (this.isPostNextRequest()){
                        this.submitProcedureNextStep(request)
                    }else{
                        this.getProcedureExecutedStep(request)
                    }
                }
            },

            submitPreviousStep(){
                let request = procedureSubmitNextRequest()
                request.lastAction = this.procedureAction
                request.url = this.procedureDataForm.previous_url.replace(process.env.VUE_APP_API_BASE_URL, '')
                request.processId = this.procedureMeta.proceso_id


                this.getProcedureExecutedStep(request)
            },

            /** Elimina valores cuyos componentes estan escondidos **/
            /** TODO: revisar para los de la Firma Digital **/
            removeUnnecessaryFormValues(){
                Object.keys(this.formValues).forEach(itemKey => {
                    if (this.formComponentsVisible[itemKey] !== undefined && !this.formComponentsVisible[itemKey]){
                        delete this.formValues[itemKey]
                    }else if (this.formValues[itemKey] === null){
                        delete this.formValues[itemKey]
                    }
                })
            },

            getColSize(field, size){
                let bootstrapSizes = ''
                if (field.extra != null && field.extra.tamano != null){
                    bootstrapSizes = field.extra.tamano
                }

                return bootstrapSizeToVuetify(bootstrapSizes, size)
            },

            /**
             * Try show Form errors if exists
             */
            showFormErrors(){
                let errors = this.proceduresStore.formErrors
                if (errors && typeof errors === 'object' ){
                    let messages = ''
                    Object.values(errors).forEach(message => {
                        if (messages !== ''){
                            messages += ', '
                        }

                        messages += message
                    })

                    if (messages !== ''){
                        this.error(messages)
                    }
                }
            },

            validDependent(field){
                let isVisible = true
                if (field.dependiente_campo != null && field.dependiente_campo != ''){
                    isVisible = this.evaluateDependentExpresion(field.dependiente_campo)
                }

                this.formComponentsVisible[field.nombre] = isVisible

                return isVisible
            },

            validateFieldReadOnly(field){
                if (field.condicion_solo_lectura != null && field.condicion_solo_lectura != ''){
                    return (field.readonly == 1 && this.evaluateDependentExpresion(field.condicion_solo_lectura))
                }

                return (field.readonly == 1)
            },

            validateDefaultValue(field){
                if (!this.formValues[field.nombre] && field.condicion_valor_default != null && field.condicion_valor_default != ''){
                    let isValid = this.evaluateDependentExpresion(field.condicion_valor_default)

                    if (isValid){
                        this.formValues[field.nombre] = this.getVariableExpresionValue(field.valor_default)
                    } else if (!isValid && field.valor_default_no_cumple != null){
                        this.formValues[field.nombre] = this.getVariableExpresionValue(field.valor_default_no_cumple)
                    }
                }
            },

            evaluateDependentExpresion(originalExpression) {
                let expression = originalExpression.replace(/ and /g, " && ").replace(/ or /g, ' || ')
                let expressionArray = expresionToArray(expression)
                let comparisonValue
                let arr
                for (let i = 0; i < expressionArray.length; i++) {
                    if (expressionArray[i].includes('@@')) {
                        let fieldToCompare = expressionArray[i].trim().replace('@@', '')
                        if (fieldToCompare.includes('->')) {
                            arr = fieldToCompare.split('->')
                            comparisonValue = this.formValues[arr[0]]
                        } else{
                            comparisonValue = this.formValues[fieldToCompare]
                        }
                        
                        if (comparisonValue === undefined) {
                            comparisonValue = this.getValueFromProcessData(fieldToCompare)
                        }

                        expression = expression.replace(expressionArray[i], `'${comparisonValue}'`)

                    }
                }
                expression = expression.replaceAll("''", "'").replaceAll(this.regex, '')
                // console.log(expression);
                try{
                    var res = evaluate(null, expression)
                } catch(e){
                    res = false
                }
                return res
            },

            getVariableExpresionValue(variableExpresion){
                if (variableExpresion.includes('@@') || variableExpresion.includes('@!')){
                    let variableName = variableExpresion.trim().replace('@@', '').replace('@!', '')
                    let variableValue = this.formValues[variableName]

                    if (variableValue == undefined){
                        variableValue = this.getValueFromProcessData(variableName)
                    }

                    return variableValue
                }

                return variableExpresion
            },

            getValueFromProcessData(valueReference) {
                let valueRefArray = valueReference.split('->')

                if (valueRefArray.length === 1){
                    return this.procedureData[valueRefArray[0]]
                }else if (valueRefArray.length === 2){
                    return this.procedureData[valueRefArray[0]][valueRefArray[1]]
                }else if (valueRefArray.length === 3){
                    return this.procedureData[valueRefArray[0]][valueRefArray[1]][valueRefArray[2]]
                }else if (valueRefArray.length === 4){
                    return this.procedureData[valueRefArray[0]][valueRefArray[1]][valueRefArray[2]][valueRefArray[3]]
                }

                return null
            },

            getLabel(field){
                if (field.validacion.required){
                    return '* ' + field.etiqueta
                }

                return field.etiqueta
            },

            findApiAjaxDependent(field){
                if (this.apiAjaxComponents[field.nombre] !== undefined){
                    return this.apiAjaxComponents[field.nombre]
                }

                return null
            },

            addAndPrepareApiAjax(field){
                field.extra.get_campos.forEach((fieldDependent, index) => {
                    let configApiAjaxItem = {
                      originFieldId: field.id,
                        originFieldName: field.nombre,
                        elementType: field.extra.get_tipo[index],
                        event: field.extra.get_valores[index]
                    }

                    let fieldDependentFinal = fieldDependent.replace(/@/g, '');
                    if (this.apiAjaxComponents[fieldDependentFinal] === undefined){
                        Vue.set(this.apiAjaxComponents, fieldDependentFinal, configApiAjaxItem)
                    }
                })
            },
            onResize() {
                if (window.innerWidth < 769) this.isMobile = true;
                else this.isMobile = false;
            },
        }


    };
</script>

<style>
    .hidden{display: none !important;}
</style>
